<script setup lang="ts">
import type { ClassBreak, ClassBreaks } from '@/composables/classBreaks'

defineOptions({
  name: 'MapLegend',
})

defineProps<{
  classBreaks?: ClassBreaks
  title?: string
  inline?: boolean
}>()

defineSlots<{
  default: () => void
  title: () => void
  label: (props: { classBreak: ClassBreak, value: number, index: number }) => void
}>()
</script>

<template>
  <div class="text-grey-700">
    <h5
      v-if="$slots.title || title"
      class="mb-2 text-base font-bold"
    >
      <slot name="title">
        {{ title }}
      </slot>
    </h5>

    <template v-if="classBreaks?.length">
      <div
        v-if="inline"
        class="grid grid-flow-col"
      >
        <DTooltip
          v-for="(classBreak, index) in classBreaks"
          :key="classBreak.upperBound"
        >
          <template #content>
            <slot
              name="label"
              :class-break="classBreak"
              :value="classBreak.from"
              :index="index"
            >
              {{ classBreak.from.toFixed(1) }} &ndash;
              {{ classBreak.upperBound.toFixed(1) }}
            </slot>
          </template>
          <div
            class="h-5"
            :style="`background:${classBreak.color}`"
          />
        </DTooltip>
      </div>

      <ul
        v-else
        class="list-unstyled m-0 space-y-2 text-grey-300"
      >
        <li
          v-for="(classBreak, index) in classBreaks"
          :key="classBreak.upperBound"
          class="text-sm"
          :class="{
            'max-w-full text-nowrap text-ellipsis': inline,
          }"
        >
          <i
            class="mr-2 inline-block h-5 w-5 rounded-xs align-middle opacity-70"
            :style="`background:${classBreak.color}`"
          />
          <slot
            name="label"
            :class-break="classBreak"
            :value="classBreak.from"
            :index="index"
          >
            {{ classBreak.from.toFixed(1) }} &ndash;
            {{ classBreak.upperBound.toFixed(1) }}
          </slot>
        </li>
      </ul>
    </template>

    <slot />
  </div>
</template>
